import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import imgMembership from "../../assets/landers_membership.png";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import React from "react";


const introText = `유료 멤버십은 SSG랜더스 APP에서 가입 가능합니다.
- 가입하고자 하는 멤버십 등급의 가입비 결제 이후부터 혜택 이용 가능합니다.
- 유료 멤버십 정책과 가입 기간은 매년 상이할 수 있으니, SSG랜더스 APP 내 유료 멤버십 모집 관련 공지사항을 참고 부탁드립니다.

※ 26시즌 유료 멤버십은 현재 모집이 마감되었습니다.`;

const common = [
  {
    title: "26시즌 유료 멤버십 가입 혜택 요약",
    image: imgMembership,
    imageAlt: "유료 멤버십 안내",
    content:
      "유료 멤버십 혜택은 2026 정규시즌 기간 동안 이용 가능합니다.\n자세한 내용은 SSG랜더스 APP 내 멤버십 모집 공지사항을 참고 부탁드립니다.",
    buttons: [
      {
        title: "멤버십 모집 공지사항 바로가기",
        link: "https://app.ssglanders.com/noticeView?seq=3079",
      },
    ],
  },
  {
    title: "26시즌 유료 멤버십 티켓 예매 혜택",
    content:
      "2026 유료 멤버십 회원은 SSG랜더스 정규시즌 홈경기 티켓 선예매가 가능합니다.\n티켓은 경기당 6매까지 예매 가능하며, 유료 멤버십 회원은 예매 수수료 무료입니다.\n\nSSG랜더스 APP 내 선예매 오픈 시간\n- 랜디, 배티 회원 : 경기 7일 전 오전 11시\n- 푸리 회원 : 경기 6일 전 오전 11시\n- 프렌즈 회원 : 경기 5일 전 오전 11시\n\n※ 선예매는 SSG랜더스 APP을 통해서만 이용 가능하며 SSG.COM 통합회원 가입이 필수입니다.",
  },
  {
    title: "26시즌 유료 멤버십 입장 혜택",
    content:
      "2026 유료 멤버십 회원은 등급별 전용 게이트를 통한 선입장이 가능합니다.\n\n1. 선입장 오픈 시간\n- 주중(월~목) : 경기 2시간 30분 전\n- 주말(금~일 및 공휴일) : 경기 3시간 전\n\n2. 입장 게이트(유료 멤버십 및 시즌티켓 회원)\n- 스타벅스 게이트 : 랜디, FAMILY, 배티, 시즌티켓, 푸리 등급 회원 전용\n- 랜디 게이트 : 랜디, FAMILY 등급 회원 전용\n- 시즌티켓 게이트 : 시즌티켓 회원 전용\n\n※ 멤버십 전용 게이트 선입장은 멤버십 회원만 가능하며, 멤버십 회원이 예매한 티켓에 한 해 동반 입장 가능합니다.\n※ 랜디/시즌티켓 게이트는 경기 시작 1시간 후까지 입장만 가능합니다.(랜디/시즌티켓 게이트를 통한 퇴장 불가)",
  },
  {
    title: "26시즌 유료 멤버십 가입 선물 안내",
    content:
      "2026 유료 멤버십 회원은 2026 정규시즌 홈경기일 인천SSG랜더스필드 내 '랜더스센터'에서 가입선물 수령 쿠폰 확인 후 수령 가능합니다.\n\n1. 수령 안내\n- 중복 수령은 불가합니다.\n- 2026 정규시즌 마지막 홈경기일까지만 수령 가능하며, 이후 수령 불가합니다.\n- 가입선물 수령 쿠폰은 SSG랜더스 APP 내 쿠폰함에 발급됩니다.\n\n2. 랜더스센터 정보\n- 위치 : 인천SSG랜더스필드 내 의무실 앞(107 섹션 앞). 경기장 내 위치해 있어 입장을 위해서는 당일 경기 티켓이 필요합니다.\n- 운영시간 : 홈경기일 게이트 오픈시간~경기종료 시",
  },
  {
    title: "26시즌 유료 멤버십 쓱7클럽+티빙 이용 안내",
    content:
      "2026 유료 멤버십 회원은 SSG.COM에서 '쓱7클럽+티빙' 서비스를 제공합니다.\n\n1. 제공 혜택\n- SSG.COM 쓱배송(주간/새벽/트레이더스) 상품 주문 시 결제금액의 7% 고정 적립\n- 신세계몰·신세계백화점몰에서 사용할 수 있는 최대 7% 할인쿠폰도 매달 지급\n- 티빙(광고형 스탠다드) 정기권\n\n2. 제공 기간 : 2026년 3월 18일 ~ 2026년 12월 31일\n\n3. 안내 사항 : 만 14세 미만 회원은 SSG.COM 및 티빙 가입이 불가해 쓱7클럽+티빙 제공이 불가합니다.\n\n※ 쓱7클럽+티빙 관련 자세한 사항은 SSG.COM 고객센터(1577-3419)로 문의 부탁드립니다.",
    buttons: [
      {
        title: "[쓱7클럽 + 티빙 혜택 이용 방법 안내 바로가기]",
        link: "https://app.ssglanders.com/noticeView?seq=3100",
      },
    ],
  },
  {
    title: "26시즌 유료 멤버십 가입 취소",
    content:
      "2026 유료 멤버십 가입 후 멤버십 혜택을 이용하지 않으신 경우에 한해 결제일로부터 14일 이내 취소(환불) 가능합니다.\n\n취소 방법 : SSG랜더스 APP > 메뉴 > 우측 상단 톱니바퀴 > 최하단[멤버십 탈퇴하기] 클릭\n- 멤버십 혜택을 이용하셨거나 가입 후 14일 경과한 경우 취소(환불) 불가합니다.\n- 결제 금액 환불은 카드사에 따라 영업일 기준 3~7일 정도 소요될 수 있습니다.",
  },
];


export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      {item.image && (
        <img src={item.image} alt={item.imageAlt || ""} className="w-full mb-4" />
      )}
      <p className="font-medium text-gray-950 whitespace-pre-line">{item.content}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map((button) => (
            <LinkItem
              key={button.title}
              title={button.title}
              url={button.link}
              isPhoneLink={button.isPhoneLink}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center min-h-12 h-auto px-4 py-2 text-center text-sm leading-snug rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const MembershipPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="멤버십" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950 whitespace-pre-line">
        {introText}
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("멤버십_전화상담")}
        />
      </div>
    </section>
  );
};

export default MembershipPage;
